// API 统一配置文件
import * as channel from './channel'
import * as user from './user'
import * as member from './member'
import * as product from './product'
import * as claim from './claim'
import * as customFrontend from './custom-frontend'
import * as customOrder from './custom-order'
import * as hyxOrder from './hyx-order'
import * as gxborder from './gxborder'
import * as note from './note'
import * as underwriteOrder from './underwrite-order'
import * as offlineBusinessOrder from './offline-business-order'
import * as employerInsurance from './employer-insurance'
import * as claimsManagement from './claims-management'
import * as company from './company'

// 统一导出所有API模块
const api = {
  channel,
  user,
  member,
  product,
  claim,
  customFrontend,
  customOrder,
  hyxOrder,
  gxborder,
  note,
  underwriteOrder,
  offlineBusinessOrder,
  employerInsurance,
  claimsManagement,
  company
}

export default api
